import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { PersonOrBusiness } from '@/types/entities/personOrBusiness';
import { AddAddressRequest } from '@/domains/addresses/types/api/requests/AddAddressRequest';

export type PartyDetailsState = {
  pageIsLoading: boolean;
  personOrBusinessNormalizedData: NormalizedV2Response | null;
  personOrBusinessType: PersonOrBusiness | null;
  personOrBusinessId: number | null;
  addressList: NormalizedV2Response[];
  addressListIsLoading: boolean;
};

const initialState: PartyDetailsState = {
  pageIsLoading: false,
  personOrBusinessNormalizedData: null,
  personOrBusinessType: null,
  personOrBusinessId: null,
  addressList: [],
  addressListIsLoading: false,
};

const partyDetailsSlice = createSlice({
  name: 'partyDetails',
  initialState,
  reducers: {
    getPersonOrBusinessData: (state, _action: PayloadAction<{ partyId: string }>) => {
      state.pageIsLoading = true;
    },
    getPersonOrBusinessDataSuccess: (
      state,
      action: PayloadAction<{ personOrBusinessNormalizedData: NormalizedV2Response }>,
    ) => {
      state.personOrBusinessNormalizedData = action.payload.personOrBusinessNormalizedData;
      state.pageIsLoading = false;
      state.personOrBusinessType = action.payload.personOrBusinessNormalizedData.entityName as PersonOrBusiness;
      state.personOrBusinessId = Number(action.payload.personOrBusinessNormalizedData.id);
    },
    getPartyAddresses: (state, _action: PayloadAction<void>) => {
      state.addressListIsLoading = true;
    },
    getPartyAddressesSuccess: (state, { payload }: PayloadAction<{ addressList: NormalizedV2Response[] }>) => {
      state.addressListIsLoading = false;
      state.addressList = payload.addressList;
    },
    addPartyAddress: (_state, _action: PayloadAction<AddAddressRequest>) => {},
    resetPartyDetailsState: () => {
      return initialState;
    },
  },
  selectors: {
    selectPartyDetailsPageIdLoading: (state) => state.pageIsLoading,
    selectPersonOrBusinessData: (state) => state.personOrBusinessNormalizedData,
    selectPartyOrBusinessType: (state) => state.personOrBusinessType,
    selectPartyOrBusinessId: (state) => state.personOrBusinessId,
    selectPartyAddresses: (state) => state.addressList,
    selectPartyAddressesIsLoading: (state) => state.addressListIsLoading,
  },
});

export const {
  getPersonOrBusinessData,
  getPersonOrBusinessDataSuccess,
  resetPartyDetailsState,
  getPartyAddresses,
  getPartyAddressesSuccess,
  addPartyAddress,
} = partyDetailsSlice.actions;
export const {
  selectPartyDetailsPageIdLoading,
  selectPersonOrBusinessData,
  selectPartyOrBusinessType,
  selectPartyOrBusinessId,
  selectPartyAddresses,
  selectPartyAddressesIsLoading,
} = partyDetailsSlice.selectors;

export const partyDetailsReducer = partyDetailsSlice.reducer;
export const partyDetailsReducerPath = partyDetailsSlice.reducerPath;
